import { State, Action, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { tap, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ProOrganizerRequestsService } from '@smatchy/sdk';

import {
  CreateProOrganizerRequest,
  CreateProOrganizerSuccess,
  CreateProOrganizerFail,
} from './pro-organizer-request.actions';
import { ProOrganizerRequest } from '../domains';

export interface ProOrganizerStateModel {
  loading: boolean;
  error: unknown | null;
  data: ProOrganizerRequest | null;
}

@State<ProOrganizerStateModel>({
  name: 'proOrganizer',
  defaults: {
    loading: false,
    error: null,
    data: null,
  },
})
@Injectable()
export class ProOrganizerState {
  constructor(private service: ProOrganizerRequestsService) {}

  // ----- Actions -----
  @Action(CreateProOrganizerRequest)
  create(ctx: StateContext<ProOrganizerStateModel>, action: CreateProOrganizerRequest) {
    ctx.patchState({ loading: true, error: null });

    return this.service
      .createRequest({
        createProOrganizerRequestDto: action.payload,
      })
      .pipe(
        tap((res) => {
            console.log('[ProOrganizer] Create Success')
          ctx.dispatch(new CreateProOrganizerSuccess(res as ProOrganizerRequest));
        }),
        catchError((err: unknown) => {
          ctx.dispatch(new CreateProOrganizerFail(err));
          return throwError(() => err);
        }),
      );
  }

  @Action(CreateProOrganizerSuccess)
  createSuccess(ctx: StateContext<ProOrganizerStateModel>, action: CreateProOrganizerSuccess) {
    ctx.patchState({
      loading: false,
      data: action.response,
    });
  }

  @Action(CreateProOrganizerFail)
  createFail(ctx: StateContext<ProOrganizerStateModel>, action: CreateProOrganizerFail) {
    ctx.patchState({
      loading: false,
      error: action.error,
    });
  }
}
